import * as tslib_1 from "tslib";
import { GasProjectDialogComponent } from './../gas-project-dialog/gas-project-dialog.component';
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { environment } from '../../environments/environment';
const APPROVER_STATUS_TTL_MS = 365 * 24 * 60 * 60 * 1000;
const IT_APPROVER_TTL_KEY = 'mmaps_it_approver_status_expires_at';
const RE_APPROVER_TTL_KEY = 'mmaps_re_approver_status_expires_at';
export class DashboardComponent {
    constructor(dialog, router, http, config, dataService, route, roleTestingService, cdr // <-- inject ChangeDetectorRef
    ) {
        this.dialog = dialog;
        this.router = router;
        this.http = http;
        this.config = config;
        this.dataService = dataService;
        this.route = route;
        this.roleTestingService = roleTestingService;
        this.cdr = cdr;
        this.userRoles = [];
        this.formId = null;
        this.checkingApproverStatus = false;
        this.mmapsITApproverStatus = '';
        this.mmapsREApproverStatus = '';
        this.environment = environment;
    }
    setApproverStatusWithTTL(type) {
        const expiresAt = (Date.now() + APPROVER_STATUS_TTL_MS).toString();
        if (type === 'it') {
            sessionStorage.setItem('mmaps_it_approver_status', 'true');
            localStorage.setItem(IT_APPROVER_TTL_KEY, expiresAt);
            return;
        }
        sessionStorage.setItem('mmaps_re_approver_status', 'true');
        localStorage.setItem(RE_APPROVER_TTL_KEY, expiresAt);
    }
    // Returns true if user is approver only (no roles, but has approver status)
    get isApproverOnly() {
        const roles = this.userRoles || [];
        const itApproverStatus = sessionStorage.getItem('mmaps_it_approver_status');
        const reApproverStatus = sessionStorage.getItem('mmaps_re_approver_status');
        return roles.length === 0 && (itApproverStatus === 'true' || reApproverStatus === 'true');
    }
    get isITApproverOnly() {
        // Approver-only, no roles, and not a Real Estate approver
        const roles = this.userRoles || [];
        const approverStatus = sessionStorage.getItem('mmaps_it_approver_status');
        // If user has no roles and approver status, but not a Real Estate user
        return roles.length === 0 && approverStatus === 'true' && !this.isRealEstateApproverOnly;
    }
    get isRealEstateApproverOnly() {
        // Approver-only, no roles, and not an IT approver
        const roles = this.userRoles || [];
        const approverStatus = sessionStorage.getItem('mmaps_re_approver_status');
        // If user has no roles and approver status, but not an IT user
        // For now, treat as Real Estate if not IT (since we can't distinguish without more info)
        return roles.length === 0 && approverStatus === 'true';
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.getEcosysData();
            if (!environment.production) {
                window.dashboardComponent = this;
            }
            let userData = JSON.parse(sessionStorage.getItem("userInfo"));
            this.currentUserEmail = userData.account.username || userData.preferred_username;
            // Apply role testing override if enabled
            this.userRoles = this.roleTestingService.applyRoleTestingOverride((userData.idTokenClaims && userData.idTokenClaims.roles) || []);
            // Check for form ID in URL parameters (for approver links)
            this.route.queryParams.subscribe(params => {
                this.formId = params['pId'] || null;
                if (this.formId) {
                    // Approver status should be set elsewhere (e.g., after API call)
                }
            });
            if (userData) {
                let stringArray = userData.account.name.split(",");
                this.firstName = stringArray[1].substring(1);
            }
            else {
                this.signOut();
            }
            // Refresh dynamic approver flags whenever dashboard loads
            this.refreshDynamicApproverStatus(userData && userData.account ? userData.account.name : "");
            // Watch for changes to dedicated approver flags
            this.mmapsITApproverStatus = sessionStorage.getItem('mmaps_it_approver_status');
            this.mmapsREApproverStatus = sessionStorage.getItem('mmaps_re_approver_status');
            window.addEventListener('storage', this.handleStorageChange.bind(this));
        });
    }
    refreshDynamicApproverStatus(accountName) {
        const userEmail = (this.currentUserEmail || '').toLowerCase();
        if (!userEmail) {
            return;
        }
        const emailAlias = userEmail.includes('@') ? userEmail.split('@')[0] : userEmail;
        const displayName = (accountName || '').trim().toLowerCase();
        const matchEmail = (raw) => {
            if (!raw)
                return false;
            const norm = String(raw).toLowerCase();
            return norm === userEmail || norm === emailAlias;
        };
        this.dataService.getItSparData({}, "reviews").subscribe((itRes) => {
            const itForms = itRes && itRes.body ? itRes.body : [];
            const isITApprover = Array.isArray(itForms) && itForms.some((form) => ((form.itSponsor && matchEmail(form.itSponsor.mail || form.itSponsor.mailNickname)) ||
                (form.approvers && form.approvers.some((a) => matchEmail(a.email || a.mailNickname || a.mail))) ||
                (form.jointOwnerCoordinator && matchEmail(form.jointOwnerCoordinator.mail)) ||
                (form.currentAssignment && matchEmail(form.currentAssignment.mail || form.currentAssignment.mailNickname)) ||
                (form.currentApprover && matchEmail(form.currentApprover.mail || form.currentApprover.mailNickname))));
            if (isITApprover) {
                this.setApproverStatusWithTTL('it');
            }
            else {
                if (sessionStorage.getItem('mmaps_it_approver_status') !== 'true') {
                    sessionStorage.removeItem('mmaps_it_approver_status');
                }
            }
            this.dataService.getRREData().subscribe((reRes) => {
                const projects = reRes && reRes.projects ? reRes.projects : (reRes || []);
                const isREApprover = Array.isArray(projects) && projects.some((project) => {
                    const assignedTo = project.assigned_to;
                    const assignedValues = Array.isArray(assignedTo)
                        ? assignedTo.map((a) => (typeof a === 'string' ? a.trim().toLowerCase() : ''))
                        : (typeof assignedTo === 'string' ? [assignedTo.trim().toLowerCase()] : []);
                    return assignedValues.includes(userEmail) || (displayName && assignedValues.includes(displayName));
                });
                if (isREApprover) {
                    this.setApproverStatusWithTTL('re');
                }
                else {
                    if (sessionStorage.getItem('mmaps_re_approver_status') !== 'true') {
                        sessionStorage.removeItem('mmaps_re_approver_status');
                    }
                }
                this.mmapsITApproverStatus = sessionStorage.getItem('mmaps_it_approver_status');
                this.mmapsREApproverStatus = sessionStorage.getItem('mmaps_re_approver_status');
                this.cdr.detectChanges();
            }, () => {
                this.mmapsREApproverStatus = '';
                this.cdr.detectChanges();
            });
        }, () => {
            this.mmapsITApproverStatus = '';
            this.cdr.detectChanges();
        });
    }
    ngOnDestroy() {
        window.removeEventListener('storage', this.handleStorageChange.bind(this));
    }
    handleStorageChange(event) {
        if (event.key === 'mmaps_it_approver_status' || event.key === 'mmaps_re_approver_status') {
            this.mmapsITApproverStatus = sessionStorage.getItem('mmaps_it_approver_status');
            this.mmapsREApproverStatus = sessionStorage.getItem('mmaps_re_approver_status');
            this.cdr.detectChanges();
        }
    }
    getEcosysData() {
        this.dataService.getEcosysData();
    }
    openGasProjectDialog() {
        this.dialog.open(GasProjectDialogComponent, {
            disableClose: true,
            width: "21.875rem",
            height: "23.063rem",
        });
    }
    signOut() {
        this.router.navigate(["/login"]);
    }
    submitTEST() {
        let callBody;
        this.http.get("assets/sample-submit.json").subscribe((result) => {
            callBody = result;
            this.submitTEST2(callBody);
        });
    }
    submitTEST2(callBody) {
        this.dataService.submitProjectTEST(callBody).subscribe((result) => {
            console.log("test done", result);
        });
    }
    openITProjectSetup() {
        const userData = sessionStorage.getItem("userInfo");
        const currentUser = sessionStorage.getItem("currentUser");
        const fullTokenPayload = sessionStorage.getItem("fullTokenPayload");
        const itApproverStatus = sessionStorage.getItem("mmaps_it_approver_status");
        const reApproverStatus = sessionStorage.getItem("mmaps_re_approver_status");
        sessionStorage.clear();
        if (userData) {
            sessionStorage.setItem("userInfo", userData);
        }
        if (currentUser) {
            sessionStorage.setItem("currentUser", currentUser);
        }
        if (fullTokenPayload) {
            sessionStorage.setItem("fullTokenPayload", fullTokenPayload);
        }
        if (itApproverStatus) {
            sessionStorage.setItem("mmaps_it_approver_status", itApproverStatus);
        }
        if (reApproverStatus) {
            sessionStorage.setItem("mmaps_re_approver_status", reApproverStatus);
        }
        this.router.navigate(["/it-project-setup"]);
    }
    openRREProjectSetup() {
        this.router.navigate(["/rre-projects"]);
    }
    openRealEstateProjectSetup() {
        // If user is accessing via approver link, navigate with the project ID
        if (this.formId) {
            this.router.navigate(["/real-estate-project"], {
                queryParams: { pId: this.formId }
            });
        }
        else {
            this.router.navigate(["/real-estate-project"]);
        }
    }
    hasGasAccess() {
        return this.userRoles.includes("MMAPS_Gas_Users");
    }
    hasOnlyGasAccess() {
        return (this.hasGasAccess() &&
            !this.hasETSAccess() &&
            !this.hasGenerationAccess() &&
            !this.hasRealEstateAccess());
    }
    hasETSAccess() {
        return (this.userRoles.includes("MMAPS_ETS_Users") ||
            this.userRoles.includes("MMAPS_ETS_Asset_Users") ||
            this.userRoles.includes("MMAPS_ETS_PAC_Users") ||
            this.userRoles.includes("MMAPS_ETS_RO_Users") ||
            sessionStorage.getItem('mmaps_it_approver_status') === 'true');
    }
    hasGenerationAccess() {
        return this.userRoles.includes("MMAPS_Generation_Users");
    }
    hasRealEstateAccess() {
        // Real estate access: role or approver status
        return this.userRoles.includes("MMAPS_Real_Estate_Users") || sessionStorage.getItem('mmaps_re_approver_status') === 'true';
    }
    hasApproverAccess() {
        // Approver status for current form
        return sessionStorage.getItem('mmaps_it_approver_status') === 'true' || sessionStorage.getItem('mmaps_re_approver_status') === 'true';
    }
    hasAnyAccess() {
        return (this.hasGasAccess() ||
            this.hasETSAccess() ||
            this.hasGenerationAccess() ||
            this.hasRealEstateAccess());
    }
}
